import React from 'react';
import { useTranslation } from 'react-i18next';
import { Country } from '../../types/Country';
import { FilterQuery } from '../../utils/filters';
import FilterResultCount from '../FilterResultCount/FilterResultCount';
import { getCountryNameByLang, getContinentByLang } from '../../utils/utils';
import { 
  RISK_CLASS_A, 
  RISK_CLASS_B, 
  RISK_CLASS_C, 
  RISK_CLASS_D, 
  RISK_CLASS_E, 
  RISK_CLASS_NONE,
  MENU_TYPE_CONTINENT_DROPDOWN,
  MENU_TYPE_COUNTRY_DROPDOWN,
  MENU_TYPE_POLICY_DROPDOWN,
  MENU_TYPE_RISK_CLASS_DROPDOWN
} from '../../utils/variables';
import FilterDropdown from '../FilterDropdown/FilterDropdown';
import { LatLng } from 'leaflet';

type Props = {
  state: Country[];
  setState: (state: Country[]) => void;
  query: FilterQuery;
  setQuery: (query: FilterQuery) => void;
  showMap: boolean;
  setCenter: (center: LatLng) => void;
}

const FilterContainer: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { state, query, setQuery, showMap, setCenter } = props;

  const getCountryNamesList = () => {
    let countries = [];
    countries = state.map(country => {
      return getCountryNameByLang(country);
    });
    return countries.sort();
  }

  const getContinents = () => {
    const continents = state.map(country => {
      return getContinentByLang(country);
    });
    const uniques = Array.from(new Set(continents));
    return uniques;
  }

  const getCoverPolicies = () => {
    return [0,1,2,3,4,5,6,7, '-'].map(num => {
      return num.toString();
    });
  }

  const getRiskClasses = () => {
    return [RISK_CLASS_A, RISK_CLASS_B, RISK_CLASS_C, RISK_CLASS_D, RISK_CLASS_E, RISK_CLASS_NONE];
  }

  return (
    <div className="filter-container">
      <div className="filter-item">
        <FilterDropdown state={state} menuType={MENU_TYPE_COUNTRY_DROPDOWN} menuItems={getCountryNamesList()} query={query} setQuery={setQuery} setCenter={setCenter}/>
        <FilterDropdown state={state} menuType={MENU_TYPE_CONTINENT_DROPDOWN} menuItems={getContinents()} query={query} setQuery={setQuery} setCenter={setCenter}/>
      </div>
      <div className="filter-item">
        <FilterDropdown state={state} menuType={MENU_TYPE_POLICY_DROPDOWN} menuItems={getCoverPolicies()} query={query} setQuery={setQuery} setCenter={setCenter}/>
        <FilterDropdown state={state} menuType={MENU_TYPE_RISK_CLASS_DROPDOWN} menuItems={getRiskClasses()} query={query} setQuery={setQuery} setCenter={setCenter}/>
      </div>
      <FilterResultCount state={state}/>
    </div>
  );
}

export default FilterContainer;